export const folderForm = {
  data: [
    {
      title: "Folder",
      rows: [
        [
          {
            key: "code",
            label: "code",
            type: "textField",
            error: "",
            validation: "",
            mask: "",
            fill: true,
          },
        ],
        [
          {
            key: "nodeText.name",
            label: "name",
            type: "textField",
            error: "",
            validation: "",
            mask: "",
            fill: true,
          },
        ],
      ],
    },
  ],
};
